import * as types from "../actions/ActionTypes";
import { formInitial } from "../store/InitialStore";
const deftValue = {
  uniqueId: "",
  type: "text",
  label: "Field Label",
  placeholder: "",
  required: false,
  options: [
    {
      optionUniqueId: "",
      label: "",
      value: "",
    },
  ],
  validationType: "string",
  validations: [
    {
      type: "required",
      params: ["Required"],
    },
  ],
  format: "",
  selectedValue: "",
  variableId: "",
  feesId: "",
  characterLimit: 10,
  allowPastDate: false,
};
export default function FormReducer(state = formInitial, action) {
  const {
    type,
    payload,
    name,
    checked,
    Checkedtype,
    value,
    index,
    id,
    option,
    feeId,
  } = action;

  const { formValues = [] } = state;
  switch (type) {
    case types.ADD_NEW_FIELD:
      return {
        ...state,
        formValues: [
          ...formValues,
          {
            ...deftValue,
            uniqueId: Date.now().toString(),
            options: [{ optionUniqueId: Date.now(), value: "", label: "" }],
          },
        ],
      };
    case types.DELETE:
      const Del = formValues.filter((Del) => Del.uniqueId != payload);
      return { ...state, formValues: Del };
    case types.VALUE_CHANGES:
      if (value == "variable") {
        formValues.find((f) => f.uniqueId == id)["selectedValue"] = 0;
      }
      if (Checkedtype == "checkbox") {
        formValues.find((f) => f.uniqueId == id)[name] = checked;
      } else if (["type", "placeholder", "required"].includes(name)) {
        formValues.find((f) => f.uniqueId == id)[name] = value;

        const item = formValues.find(
          (f) =>
            f.uniqueId == id &&
            name == "type" &&
            value != "instruction" &&
            f.type == value &&
            f.placeholder != ""
        );

        if (item != undefined) {
          formValues.find((f) => f.uniqueId == id)["placeholder"] = "";
        }
      } else if (["characterLimit"].includes(name)) {
        formValues.find((f) => f.uniqueId == id)["characterLimit"] = value;
      } else {
        formValues.find((f) => f.uniqueId == id)["label"] = value;
        formValues.find((f) => f.uniqueId == id)["variableId"] = option;
        formValues.find((f) => f.uniqueId == id)["feesId"] = feeId;
      }

      return { ...state, formValues: formValues };
    case types.ADD_OPTION:
      return { ...state, formValues: payload };
    case types.OPTION_VALUES:
      formValues.find((l) => l.uniqueId == id).options[index][name] = value;
      return { ...state, formValues: formValues };
    case types.OPTION_DELETE:
      formValues.find((l) => l.uniqueId == id).options.splice(index, 1);
      return { ...state, formValues: formValues };
    case types.DRAG_DROP:
      return { ...state, formValues: payload };
    case types.ADD_DUPLICATE:
      const { options = {} } = formValues[index];
      const filter = formValues.filter((f) => f.uniqueId == id)[0];
      formValues.splice(index, 0, {
        ...filter,
        uniqueId: Date.now().toString(),
        options: options.map((data, index) => ({
          optionUniqueId: (Date.now() + index).toString(),
          label: data.label,
          value: data.value,
        })),
      });
      return { ...state, formValues: formValues };
    case types.RESET_STATE:
      return {
        ...state,
        formValues: [
          {
            uniqueId: Date.now().toString(),
            type: "text",
            label: "Field Label",
            placeholder: "",
            required: false,
            options: [
              { optionUniqueId: Date.now().toString(), label: "", value: "" },
            ],
            format: "",
            validationType: "string",
            validations: [
              {
                type: "required",
                params: ["Required"],
              },
            ],
            selectedValue: "",
          },
        ],
      };

    case types.FORM_DETAILS:
      return { ...state, formValues: payload };
    case types.NEW_FROM:
      return {
        ...state,
        formValues: [
          {
            uniqueId: Date.now().toString(),
            type: "text",
            label: "Field Label",
            placeholder: "",
            required: false,
            options: [
              {
                optionUniqueId: "",
                label: "",
                value: "",
              },
            ],
            validationType: "string",
            validations: [
              {
                type: "required",
                params: ["Required"],
              },
            ],
            format: "",
            selectedValue: "",
          },
        ],
      };
    case types.SAVE_VALUE:
      return {
        ...state,
        formValues: payload,
      };

    case types.SAVE_FILED_VALUE:
      
      formValues.find((s) => s.uniqueId == name)["selectedValue"] = payload;

      return {
        ...state,
        formValues: formValues,
      };

    default:
      return state;
  }
}
